import React from "react";
import DesktopNavBar from "./DesktopNavBar";
import MobileNavBar from "./MobileNavBar";
import useDesktopSize from "../../utils/hooks/useDesktopSize";

const NavBar: React.FC = () => {
  const isDesktop = useDesktopSize();
  return <React.Fragment>{isDesktop ? <DesktopNavBar /> : <MobileNavBar />}</React.Fragment>;
};

export default NavBar;
